module.exports = __webpack_public_path__ + "static/media/typeface-research.f25feec1.png";